import React from "react";
import {
  Card,
  CardContent,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  title: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 12,
  },
  note: {
    marginTop: 12,
    fontSize: 12,
    color: "#666",
  },
  tableCell: {
    borderBottom: "1px solid #efefef",
  },
  eventCell: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: 10,
  },
  loadingWrap: {
    minHeight: 140,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const BudgetByBoostTable = ({ rows = [], loading = false }) => {
  const classes = useStyles();

  return (
    <Card>
      <CardContent>
        <Typography className={classes.title}>ブースト別 撮影集計</Typography>
        {loading ? (
          <div className={classes.loadingWrap}>
            <CircularProgress size={28} />
          </div>
        ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell className={classes.tableCell}>イベント</TableCell>
              <TableCell className={classes.tableCell} align="right">対象電柱</TableCell>
              <TableCell className={classes.tableCell} align="right">撮影数</TableCell>
              <TableCell className={classes.tableCell} align="right">排出金額</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.id || row.name}>
                <TableCell className={classes.tableCell}>
                  <div className={classes.eventCell}>
                    {row.name}
                  </div>
                </TableCell>
                <TableCell className={classes.tableCell} align="right">{row.target}</TableCell>
                <TableCell className={classes.tableCell} align="right">{row.shots}</TableCell>
                <TableCell className={classes.tableCell} align="right">{row.payout}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        )}
        <Typography className={classes.note}>
          ※ 対象電柱数はイベント開始時点で未撮影かつ報酬残ありの電柱のみを計上
        </Typography>
      </CardContent>
    </Card>
  );
};

export default BudgetByBoostTable;
